import React from "react";

const ProgressBar = ({ totalSteps, currentStep }) => {
  return (
    <div className="flex justify-end gap-1 pt-3">
      {[...Array(totalSteps)].map((step, index) => {
        if (index + 1 <= currentStep) {
          return (
            <div
              className={`h-[4px] w-[25%] ${currentStep === totalSteps ? "bg-red-400" : "bg-primary-500"}  rounded-[18px] `}
            ></div>
          );
        } else {
          return (
            <div
              className={` h-[4px] w-[25%] bg-gray-150 rounded-[18px] `}
            ></div>
          );
        }
      })}
    </div>
  );
};

export default ProgressBar;
